import React, { useRef, useState, useEffect } from "react";
import { Menu } from "primereact/menu";
import { TieredMenu } from "primereact/tieredmenu";
import { Button } from "primereact/button";
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import Dashboard from "../Pages/Dashboard";
import { Toast } from "primereact/toast";
import MobileUpload from "../Pages/MobileUpload";
import Reports from "../Pages/Reports";
import Section_1 from '../Pages/DashboardTabs/Section_1';
import Section_2 from '../Pages/DashboardTabs/Section_2';
import Section_3 from '../Pages/DashboardTabs/Section_3';
import Section_4 from '../Pages/DashboardTabs/Section_4';
import Section_5 from '../Pages/DashboardTabs/Section_5';
import Section_6 from '../Pages/DashboardTabs/Section_6';

const Main = () => {
  const menu = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("");
  const toast = useRef(null);
  const fldRoleCode = sessionStorage.getItem("RoleCode");
  // console.log("roll code", fldRoleCode);

  useEffect(() => {
    setActiveTab(location.pathname);
  }, [location.pathname]);
  const PageNotFound = () => {
    return (
      <>
        <h1 style={{textAlign:"center"}}>404 Page not found</h1>
        <p  style={{textAlign:"center"}}>The page you are looking for does not exist.</p>
      </>
    );
  };
  const displayContent = () => {
    return (
      // <Routes>
      //   <Route exact path="/dashboard" element={<Dashboard />} />
      //   <Route exact path="/mobileUpload" element={<MobileUpload/>}/>
      //   <Route exact path="/reports" element={<Reports/>}/>

      // </Routes>
      <Routes>
        {fldRoleCode === "3" && (
          <>
            <Route exact path="/dashboard" element={<Dashboard />} />
            <Route exact path="/mobileUpload" element={<MobileUpload />} />
             <Route exact path="/section1" element={<Section_1 />} />
            <Route exact path="/section2" element={<Section_2 />} />
            <Route exact path="/section3" element={<Section_3 />} />
            <Route exact path="/section4" element={<Section_4 />} />
            <Route exact path="/section5" element={<Section_5 />} />
            <Route exact path="/section6" element={<Section_6 />} />
            <Route exact path="/reports" element={<Reports />} />
          </>
        )}
        {fldRoleCode === "1" && (
          <>
            <Route exact path="/dashboard" element={<Dashboard />} />
            <Route exact path="/section1" element={<Section_1 />} />
            <Route exact path="/section2" element={<Section_2 />} />
            <Route exact path="/section3" element={<Section_3 />} />
            <Route exact path="/section4" element={<Section_4 />} />
            <Route exact path="/section5" element={<Section_5 />} />
            <Route exact path="/section6" element={<Section_6 />} />
            <Route exact path="/reports" element={<Reports />} />
          </>
        )}
        <Route exact path="/*" element={<PageNotFound />} />
      </Routes>
    );
  };

  const items1 = [
    {
      label: "Log out",
      icon: "pi pi-sign-out",
      command: () => {
        sessionStorage.clear();
        navigate("/");
      },
    },
  ];

const menuItems = [
  {
  label: (
    <p className={`m-0 pt-1 ${activeTab === "/main/section1" ? "active-text" : ""}`}>
      Socio-economic and demographic determinants 
    </p>
  ),
  icon: <i className="fa fa-users" style={{ fontSize: "20px", paddingRight: "10px"  }} />, // People / community
  className: activeTab === "/main/section1" ? "active-tab" : "",
  command: () => {
    setActiveTab("/main/section1");
    navigate("/main/section1");
  },
},
{
  label: (
    <p className={`m-0 pt-1 ${activeTab === "/main/section2" ? "active-text" : ""}`}>
       Environmental determinants
    </p>
  ),
  icon: <i className="fa fa-leaf" style={{ fontSize: "20px", paddingRight: "10px" }} />, // Environment / nature
  className: activeTab === "/main/section2" ? "active-tab" : "",
  command: () => {
    setActiveTab("/main/section2");
    navigate("/main/section2");
  },
},
{
  label: (
    <p className={`m-0 pt-1 ${activeTab === "/main/section3" ? "active-text" : ""}`}>
      Behavioral determinants
    </p>
  ),
  icon: <i className="fa fa-brain" style={{ fontSize: "20px", paddingRight: "10px" }} />, // Behavior / mindset
  className: activeTab === "/main/section3" ? "active-tab" : "",
  command: () => {
    setActiveTab("/main/section3");
    navigate("/main/section3");
  },
},
{
  label: (
    <p className={`m-0 pt-1 ${activeTab === "/main/section4" ? "active-text" : ""}`}>
      Health Service determinant
    </p>
  ),
  icon: <i className="fa fa-hospital" style={{ fontSize: "20px", paddingRight: "10px" }} />, // Health service / hospital
  className: activeTab === "/main/section4" ? "active-tab" : "",
  command: () => {
    setActiveTab("/main/section4");
    navigate("/main/section4");
  },
},
{
  label: (
    <p className={`m-0 pt-1 ${activeTab === "/main/section5" ? "active-text" : ""}`}>
       Health status of the population
    </p>
  ),
  icon: <i className="fa fa-heartbeat" style={{ fontSize: "20px", paddingRight: "10px" }} />, // Population health / heartbeat
  className: activeTab === "/main/section5" ? "active-tab" : "",
  command: () => {
    setActiveTab("/main/section5");
    navigate("/main/section5");
  },
},

  // {
  //   label: (
  //     <p className={`m-0 pt-1 ${activeTab === "/main/section6" ? "active-text" : ""}`}>
  //       Health services
  //     </p>
  //   ),
  //   icon: <i className="pi pi-heart" style={{ fontSize: "20px", paddingRight: "10px" }} />,
  //   className: activeTab === "/main/section6" ? "active-tab" : "",
  //   command: () => {
  //     setActiveTab("/main/section6");
  //     navigate("/main/section6");
  //   },
  // },
  {
    label: (
      <p className={`m-0 pt-1 ${activeTab === "/main/dashboard" ? "active-text" : ""}`}>
        Map View
      </p>
    ),
    icon: <i className="fa fa-map" style={{ fontSize: "20px", paddingRight: "10px" }} />, 
    className: activeTab === "/main/dashboard" ? "active-tab" : "",
    command: () => {
      setActiveTab("/main/dashboard");
      navigate("/main/dashboard");
    },
  },
  {
    label: (
      <p className={`m-0 pt-1 ${activeTab === "/main/reports" ? "active-text" : ""}`}>
        Reports
      </p>
    ),
    icon: <i className="fa fa-file-alt" style={{ fontSize: "20px", paddingRight: "10px" }} />, 
    className: activeTab === "/main/reports" ? "active-tab" : "",
    command: () => {
      setActiveTab("/main/reports");
      navigate("/main/reports");
    },
  },
];

  

  const superMenuItems = [
  {
    label: (
      <p
        className={`m-0 ${
          activeTab === "/main/mobileUpload" ? "active-text" : ""
        }`}
      >
        Mobile apk upload
      </p>
    ),
    icon: (
      <i
        className="pi pi-file-arrow-up"
        style={{ fontSize: "22px", paddingRight: "10px" }}
      />
    ),
    className: activeTab === "/main/mobileUpload" ? "active-tab" : "",
    command: () => {
      setActiveTab("/main/mobileUpload");
      navigate("/main/mobileUpload");
    },
  },
  {
    label: (
      <p className={`m-0 pt-1 ${activeTab === "/main/section1" ? "active-text" : ""}`}>
         Socio-economic and demographic determinants 
      </p>
    ),
    icon: <i className="pi pi-users" style={{ fontSize: "20px", paddingRight: "10px" }} />,
    className: activeTab === "/main/section1" ? "active-tab" : "",
    command: () => {
      setActiveTab("/main/section1");
      navigate("/main/section1");
    },
  },
  {
    label: (
      <p className={`m-0 pt-1 ${activeTab === "/main/section2" ? "active-text" : ""}`}>
        Demographic Determinants
      </p>
    ),
    icon: <i className="pi pi-id-card" style={{ fontSize: "20px", paddingRight: "10px" }} />,
    className: activeTab === "/main/section2" ? "active-tab" : "",
    command: () => {
      setActiveTab("/main/section2");
      navigate("/main/section2");
    },
  },
  {
    label: (
      <p className={`m-0 pt-1 ${activeTab === "/main/section3" ? "active-text" : ""}`}>
        Behavioral determinants
      </p>
    ),
    icon: <i className="fa fa-brain" style={{ fontSize: "20px", paddingRight: "10px" }} />,
    className: activeTab === "/main/section3" ? "active-tab" : "",
    command: () => {
      setActiveTab("/main/section3");
      navigate("/main/section3");
    },
  },
  {
    label: (
      <p className={`m-0 pt-1 ${activeTab === "/main/section4" ? "active-text" : ""}`}>
        Socio cultural determinants
      </p>
    ),
    icon: <i className="fa fa-globe" style={{ fontSize: "20px", paddingRight: "10px" }} />,
    className: activeTab === "/main/section4" ? "active-tab" : "",
    command: () => {
      setActiveTab("/main/section4");
      navigate("/main/section4");
    },
  },
  {
    label: (
      <p className={`m-0 pt-1 ${activeTab === "/main/section5" ? "active-text" : ""}`}>
        Economic determinants
      </p>
    ),
    icon: <i className="pi pi-wallet" style={{ fontSize: "20px", paddingRight: "10px" }} />,
    className: activeTab === "/main/section5" ? "active-tab" : "",
    command: () => {
      setActiveTab("/main/section5");
      navigate("/main/section5");
    },
  },
  {
    label: (
      <p className={`m-0 pt-1 ${activeTab === "/main/section6" ? "active-text" : ""}`}>
        Health services
      </p>
    ),
    icon: <i className="pi pi-heart" style={{ fontSize: "20px", paddingRight: "10px" }} />,
    className: activeTab === "/main/section6" ? "active-tab" : "",
    command: () => {
      setActiveTab("/main/section6");
      navigate("/main/section6");
    },
  },
  {
    label: (
      <p className={`m-0 pt-1 ${activeTab === "/main/dashboard" ? "active-text" : ""}`}>
        Map View
      </p>
    ),
    icon: <i className="pi pi-map-marker" style={{ fontSize: "20px", paddingRight: "10px" }} />,
    className: activeTab === "/main/dashboard" ? "active-tab" : "",
    command: () => {
      setActiveTab("/main/dashboard");
      navigate("/main/dashboard");
    },
  },
  {
    label: (
      <p className={`m-0 pt-1 ${activeTab === "/main/reports" ? "active-text" : ""}`}>
        Reports
      </p>
    ),
    icon: <i className="pi pi-file" style={{ fontSize: "20px", paddingRight: "10px" }} />,
    className: activeTab === "/main/reports" ? "active-tab" : "",
    command: () => {
      setActiveTab("/main/reports");
      navigate("/main/reports");
    },
  },
];

  return (
    <>
      <div className="sidebar">
        <Toast ref={toast} position="top-right" />

        <div className="flex justify-content-center mt-5">
          <img src="/Swaasthya-Geoplus.svg" alt="logo" style={{ width: "120px" }} />
        </div>
        {fldRoleCode === "3" && (
          <>
            <div className="menu-container">
              <Menu model={superMenuItems} className="sidebarMenu mt-5 pl-4" />
            </div>
            <div
              className="sidebartieredmenu-container"
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "15px",
              }}
            >
              <TieredMenu model={items1} popup ref={menu} />
              <Button
                className="sidebartieredmenu pi pi-user"
                onClick={(e) => menu.current.toggle(e)}
              >
                <span className="menuFont">Super Admin</span>{" "}
                <i className="pi pi-chevron-up" />
              </Button>
            </div>
          </>
        )}
        {fldRoleCode === "1" && (
          <>
            <div className="menu-container">
              <Menu model={menuItems} className="sidebarMenu mt-5 pl-4" />
            </div>
            <div
              className="sidebartieredmenu-container"
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "15px",
              }}
            >
              <TieredMenu model={items1} popup ref={menu} />
              <Button
                className="sidebartieredmenu pi pi-user"
                onClick={(e) => menu.current.toggle(e)}
              >
                <span className="menuFont">Administrator</span>{" "}
                <i className="pi pi-chevron-up" />
              </Button>
            </div>
          </>
        )}
      </div>
      <div className="cardStyle">
        <div>{displayContent()}</div>
      </div>
    </>
  );
};
export default Main;
